import { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Web3 from "web3";
import UiButton from "../../components/button";
import Loader from "../loader";

import {
  SuccessToast,
  FailureToast,
  ToastOptions,
} from "../../utils/constants";
import { toast } from "react-toastify";
import ERC20ABI from "../../utils/abi/ERC20.json";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import { providers } from "ethers";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { useGlobal } from "../../context/globalContext";
import { Security } from "@verified-network/verified-sdk";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function Resolution(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [ballot, setBallot] = useState(true);
  const [loading, setLoading] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  const castVote = async () => {
    setLoading(true);
    const securityTokenContract = new Security(
      signer,
      props.data.securityAddress
    );

    let paymentToken;

    if (
      verifiedWalletDetails &&
      Object?.keys(verifiedWalletDetails)?.length > 0
    ) {
      const cashTokens = await getAllVerifiedCashBalances(
        chainId,
        web3,
        account
      );

      if (!cashTokens || cashTokens?.length === 0) {
        setLoading(false);
        toast.error(
          "No valid Cash Token on this network. Change network and try again.",
          ToastOptions
        );

        return;
      }
      paymentToken = cashTokens[0];
      const txQuote = await securityTokenContract._getMeeQuote(
        cashTokens[0]?.address,
        "vote",
        [props.data.date, ballot]
      );

      if (
        Number(cashTokens[0]?.balance) === 0 ||
        Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
      ) {
        setLoading(false);
        toast.error(
          `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
          ToastOptions
        );

        return;
      }
    }
    try {
      await securityTokenContract
        .vote(
          props.data.date,
          ballot,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            toast.success(SuccessToast(), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error(FailureToast(), ToastOptions);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(FailureToast(), ToastOptions);
        });
    } catch (err) {
      let error = { err };
      setLoading(false);
      toast.error(FailureToast(), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Cast your vote</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <DropdownButton
                id="dropdown-basic-button"
                title={ballot ? "Yes" : "No"}
              >
                <Dropdown.Item onClick={(e) => setBallot(true)}>
                  Yes
                </Dropdown.Item>
                <Dropdown.Item onClick={(e) => setBallot(false)}>
                  No
                </Dropdown.Item>
              </DropdownButton>
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && signer && chainId && account) {
                    castVote();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Vote"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function InvestorVoting(props) {
  return <Resolution {...props} />;
}
